export enum CrmIntegrationNames {
  ELEAD = 'elead',
  VIN_SOLUTION = 'vinsolutions',
  DEALERSOCKET = 'dealersocket',
}
